import React from "react"
import { useStaticQuery, graphql } from "gatsby"
//components
import Layout from "../components/layout"
import SEO from "../components/seo"
import Categorys from "../components/Categorys"
import Icon from "../components/icon/Icon"
import { TagTitle } from "./../styles/global"

export interface BlogIndexProps {
  location?: any
}
export const BlogIndex: React.FC<BlogIndexProps> = ({ location }) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)
  const siteTitle = data.site.siteMetadata.title
  return (
    <Layout location={location} title={siteTitle}>
      <TagTitle>
        <Icon icon={"category"} width={15} height={15} />
        Tag`s
      </TagTitle>
      <Categorys />
      <SEO title="All TAG`S" />
    </Layout>
  )
}
export default BlogIndex
